import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { ActivityItems } from '../Launchpad.types';

type LaunchpadContextState = {
  actionTypes: string[];
  activityItems: ActivityItems;
  activityItemsCount: number;
  handleClearFilters: () => void;
  handleLoadMore: () => void;
  handleRetry: () => void;
  hasError?: boolean;
  isExpanded: boolean;
  isLoading?: boolean;
  isLoadingMore: boolean;
  resourceTypes: string[];
  setActionTypes: (actionTypes: string[]) => void;
  setIsExpanded: (isExpanded: boolean) => void;
  setResourceTypes: (resourceTypes: string[]) => void;
};

export const DEFAULT_LAUNCHPAD_CONTEXT: LaunchpadContextState = {
  actionTypes: [],
  activityItems: [],
  activityItemsCount: 0,
  handleClearFilters: noop,
  handleLoadMore: noop,
  handleRetry: noop,
  hasError: false,
  isExpanded: false,
  isLoading: false,
  isLoadingMore: false,
  resourceTypes: [],
  setActionTypes: noop,
  setIsExpanded: noop,
  setResourceTypes: noop,
};

export const LaunchpadContext = createContext<LaunchpadContextState>(DEFAULT_LAUNCHPAD_CONTEXT);

export const useLaunchpadContext = (): LaunchpadContextState => {
  const context = useContext(LaunchpadContext);

  if (!context) {
    throw new Error('useLaunchpadContext must be used within a LaunchpadProvider');
  }
  return context;
};
